var _rect, _rect2, _rect3, _path, _path2, _ellipse, _ellipse2, _ellipse3, _path3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _circle, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKycBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 85,
    viewBox: "0 0 104 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 103.417,
    height: 85,
    rx: 5.66667,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 103.417,
    height: 85,
    rx: 5.66667,
    fill: "#00142A",
    fillOpacity: 0.04
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.75,
    y: 12.75,
    width: 77.9167,
    height: 48.1667,
    rx: 2.83333,
    fill: "url(#paint0_linear_1889_7677)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.59 44.2434C20.2272 45.8186 19.899 48.2056 19.8334 49.5839H45.8248C45.3654 48.2056 45.0372 45.8186 42.8712 44.2434C40.9022 42.8114 35.5858 42.561 32.8291 42.6922C30.2037 42.561 24.5252 42.9533 22.59 44.2434Z",
    fill: "#2B547A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6851 41.5239C30.0308 40.9708 29.8292 39.8531 29.6851 39.3634C30.4918 39.153 31.6086 38.9084 32.6234 38.7752C34.1092 38.5802 35.376 38.624 35.1296 39.3634C34.7147 40.6078 35.7633 42.244 36.3394 42.9066C35.7345 43.4539 34.7839 44.5485 32.3641 44.5485C30.6357 44.5485 29.1666 43.4539 28.6481 42.9066C28.8497 42.6761 29.3395 42.077 29.6851 41.5239Z",
    fill: "#E8A97C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.6519,
    cy: 33.38,
    rx: 5.31643,
    ry: 8.46691,
    fill: "#F4BD95"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.1421,
    cy: 35.1395,
    rx: 0.984524,
    ry: 1.77214,
    transform: "rotate(-13.9206 27.1421 35.1395)",
    fill: "#F4BD95"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.984524,
    ry: 1.77214,
    transform: "matrix(-0.97063 -0.240577 -0.240577 0.97063 37.7749 35.1395)",
    fill: "#F4BD95"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1296 32.1041C27.8703 33.6597 27.5728 34.3237 27.179 34.7831C26.7852 33.3392 25.9964 29.8353 26.9416 27.4725C28.123 24.5189 30.3327 24.3504 32.1049 24.1535C33.877 23.9566 35.9992 24.1251 37.3775 25.3065C38.7559 26.488 38.4375 27.0962 38.2406 28.4745C39.3433 29.2621 39.4122 30.7564 39.0184 31.4128L37.8085 34.7831L37.5744 34.1672C37.3775 33.0547 37.3775 32.5526 37.3775 31.6075C37.3775 30.4261 36.9084 29.9373 36.3394 29.6844C35.5616 29.3387 34.0061 29.7708 33.6604 29.8353C33.3147 29.8999 33.3147 29.9436 32.7962 29.9436C32.2777 29.9436 32.7098 29.9863 31.932 29.8353C31.1543 29.6844 29.6239 29.3693 28.9938 29.6844C28.2061 30.0782 28.3238 30.9388 28.1296 32.1041Z",
    fill: "#3C3B3B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 25.5,
    width: 7.08333,
    height: 2.83333,
    fill: "#82A3C2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 62.3333,
    y: 25.5,
    width: 7.08333,
    height: 2.83333,
    fill: "#595959"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 32.583,
    width: 7.08333,
    height: 2.83333,
    fill: "#82A3C2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 62.3333,
    y: 32.583,
    width: 11.3333,
    height: 2.83333,
    fill: "#595959"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 39.6665,
    width: 7.08333,
    height: 2.83333,
    fill: "#82A3C2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 62.3333,
    y: 39.6665,
    width: 17,
    height: 2.83333,
    fill: "#595959"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 46.75,
    width: 7.08333,
    height: 2.83333,
    fill: "#82A3C2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 62.3333,
    y: 46.75,
    width: 21.25,
    height: 2.83333,
    fill: "#595959"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.7083,
    cy: 64.458,
    r: 10.625,
    fill: "#2DBD96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3045 64.0709L50.5751 67.3414L56.101 61.8154",
    stroke: "white",
    strokeWidth: 1.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1889_7677",
    x1: 12.75,
    y1: 19.8333,
    x2: 89.25,
    y2: 59.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0552594,
    stopColor: "#9FEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#FFE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBF6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycBg);
export default __webpack_public_path__ + "static/media/kycBG.d5d29ad561295b3cbc75202e439b0560.svg";
export { ForwardRef as ReactComponent };